export function setBusy(message) {
    getElement("status").textContent = message;
}
export function showError(error) {
    const message = error instanceof Error ? error.message : "Unexpected error";
    getElement("status").textContent = message;
}
export function getElement(id) {
    const element = document.getElementById(id);
    if (!element) {
        throw new Error(`Missing element: ${id}`);
    }
    return element;
}
export function escapeHtml(value) {
    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
export function escapeAttribute(value) {
    return escapeHtml(value);
}
